/* eslint-disable react/prop-types */
import "./styles.css";
// import { AccordionWrapper, AccordionItem } from "custom-react-accordion";
import general from "./FAQ/general.json";
import algos from "./FAQ/algos.json";
import appDev from "./FAQ/appDev.json";
import devOps from "./FAQ/devOps.json";
import ee from "./FAQ/EE.json";
import robotics from "./FAQ/robotics.json";
import ml from "./FAQ/ml.json";
import cybersecurity from "./FAQ/cybersecurity.json";
import networks from "./FAQ/networks.json";
import blockchain from "./FAQ/blockchain.json";

import { useState } from "react";
// import uiux from "./FAQ/uiux.json";
// import webDev from "./FAQ/webDev.json";
function FaqAccordion({ curProfile }) {
  const [active, setActive] = useState(-1);
  const faq = [
    general,
    algos,
    appDev,
    devOps,
    ee,
    robotics,
    ml,
    cybersecurity,
    networks,
    blockchain
  ];
  return (
    <div id="faq-content-container">
      {/* <AccordionWrapper>
        {faq[curProfile].map((item, index) => (
          <AccordionItem 
            key={index}
            index={index}
            title={item.title}
            description={item.description}
          />
        ))}
      </AccordionWrapper> */}
      <div className="accordion-wrapper">
        {faq[curProfile].map((item, index) => (
          <div className="accordion-item" key={index}>
            <h3 className="accordion-title">
              <button
                onClick={() => {
                  if(active === index){
                    setActive(-1);
                  }else{
                    setActive(index);
                  }
                }}
                className={active === index ? "active" : "inactive"}
                aria-expanded={active === index ? "true" : "false"}
                aria-controls={"sect-" + (index + 1)}
                aria-disabled={active === index ? "true" : "false"}
              >
                <span className="title-wrapper">{item.title}</span>
                <span className="icon-wrapper">
                  <span className={active === index ? "plus" : "minus"}></span>
                </span>
              </button>
            </h3>
            <div className="accordion-panel">
              <div
                className={active === index ? "panel-open" : "panel-close"}
                id={"sect-" + (index + 1)}
              >
                <p>{item.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FaqAccordion;
